<template>
  <div class="inline">
    <a-button :type="buttonType" :size="buttonSize" @click="handleShow">{{ buttonText }}</a-button>

    <a-modal :width="1000" :visible="visible" title="编辑题目" @ok="handleOk" :destroyOnClose="true" @cancel="handleCancel">
      <a-row type="flex" justify="start" :gutter="[16, 16]" :id="`modal${qid}`" style="position: relative;">
        <a-col :span="16">
          <a-radio-group v-model="form.typestr" @change="handleQuestionTypeChanged">
            <template v-for="item in questionTypes">
              <a-radio-button :value="item.value" :key="item.value">{{ item.label }}</a-radio-button>
            </template>
          </a-radio-group>
        </a-col>
        <a-col :span="8">
          <a-rate v-model="form.star" />
        </a-col>
        <a-col :span="16">
          <template>
            <div class="form-group">
              <or-rich-input v-model="form.title" label="题干" />
            </div>
          </template>

          <template v-if="form.typestr === 'VOICE' || form.typestr === 'COMPLETION' || form.typestr === 'SINGLE_CHOICE'">

            <or-upload v-model="form.voice" style="margin-bottom: 1rem;" mode="mp3" button-text="上传示范语音" />

            <a-button size="small" @click="qingchu" v-if="form.voice != ''">清除语音
            </a-button>
          </template>

          <template v-if="form.typestr === 'PREVIEW'">
            <or-upload v-model="form.previewvideo" style="margin-bottom: 1rem;" button-text="上传预习视频" />
          </template>

          <template v-else>
            <template v-if="form.typestr === 'SINGLE_CHOICE'">
              <div class="form-group" v-for="(option, index) in form.options" :key="index">
                <or-rich-input :label="`选项 ${String.fromCharCode(65 + index)}`" :value="option"
                  @input="handleOptionInput(index, $event)" />
                <a-icon class="remove" v-if="form.options.length > 2" type="minus-circle"
                  @click="handleRemoveOption(index)" />
              </div>

              <div class="form-group">
                <a-button size="small" type="dashed" @click="handleAddOption" v-if="form.options.length < 6" block>添加选项
                </a-button>
              </div>
            </template>

            <template v-if="form.typestr === 'SINGLE_CHOICE'">
              <div class="form-group">
                <div class="label">正确答案:</div>
                <a-radio-group v-model="form.answer">
                  <template v-for="(item, index) in form.options">
                    <a-radio :value="String.fromCharCode(65 + index)" :key="index">{{ String.fromCharCode(65 + index) }}
                    </a-radio>
                  </template>
                </a-radio-group>
              </div>
            </template>

            <template v-if="form.typestr === 'JUDGMENT'">
              <div class="form-group">
                <div class="label">正确答案:</div>
                <a-radio-group v-model="form.answer">
                  <a-radio :value="1">正确</a-radio>
                  <a-radio :value="0">错误</a-radio>
                </a-radio-group>

              </div>
            </template>

            <template v-if="form.typestr === 'COMPLETION'">
              <div class="form-group">
                <div class="label">正确答案:</div>
                <a-select v-model="answer_cnt" style="width: 80px;">
                  <a-select-option :value="1">1个</a-select-option>
                  <a-select-option :value="2">2个</a-select-option>
                  <a-select-option :value="3">3个</a-select-option>
                  <a-select-option :value="4">4个</a-select-option>
                  <a-select-option :value="5">5个</a-select-option>
                  <a-select-option :value="6">6个</a-select-option>
                  <a-select-option :value="7">7个</a-select-option>
                </a-select>
                <template v-for=" item in answers">
                  <a-input v-if="item.id <= answer_cnt" v-model="item.val" :key="item.id" :placeholder="'第' + (item.id) + '个'"
                    style="margin-left:5px;width: 80px" />
                </template>
                <div class="form-group">
                  <div class="label">学生提交解析:</div>
                  <a-radio-group v-model="form.need_student_analysis">
                    <a-radio :value="1" :key="1">是
                    </a-radio>
                    <a-radio :value="0" :key="0">否
                    </a-radio>

                  </a-radio-group>
                </div>
              </div>
            </template>

          </template>
          <or-rich-input v-model="form.analysis" label="解析" />
        </a-col>
        <a-col :span="8">
          <div class="form-group">
            <a-input v-model="form.node_str" placeholder="知识点编号" />
          </div>
          <div class="form-group">
            <a-tree-select treeNodeFilterProp="title" showSearch style="width:100%" placeholder="章节信息"
              v-model="form.chapter_id" :replaceFields="{ children: 'children', title: 'name', key: 'pid', value: 'pid' }"
              :tree-data="basicChapterList"></a-tree-select>
          </div>
          <div class="form-group">
            <a-select v-model="form.subject" placeholder="学科" style="width: 100%;">
              <a-select-option :key="1" :value="1">数学</a-select-option>
              <a-select-option :key="2" :value="2">英语</a-select-option>
              <a-select-option :key="3" :value="3">语文</a-select-option>
              <a-select-option :key="4" :value="4">化学</a-select-option>
              <a-select-option :key="5" :value="5">物理</a-select-option>
            </a-select>

          </div>

          <!-- <div class="form-group">
                        <a-select v-model="form.grade_id" placeholder="年级" style="width: 100%;">
                            <a-select-option v-for="item in  basicGradeList" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="form-group">
                        <a-select v-model="form.chapter_id" placeholder="章节" style="width: 100%;">
                            <a-select-option v-for="item in  basicChapterList" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </div>
-->


          <div class="form-group">
            <a-tree-select treeNodeFilterProp="title" showSearch class="knowledge"
              :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }" :treeData="questionNodeList"
              v-model="form.node_id" placeholder="主知识节点" :getPopupContainer="getPopupContainer"
              allowClear></a-tree-select>
          </div>
          <div class="form-group">
            <a-tree-select treeNodeFilterProp="title" showSearch class="knowledge" v-model="node_ids"
              :treeData="questionNodeList" placeholder="附加知识节点"
              :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }" treeCheckStrictly treeCheckable
              :getPopupContainer="getPopupContainer" allowClear></a-tree-select>
          </div>

          <div class="form-group">
            <a-select mode="tags" v-model="form.tag" placeholder="标签" style="width: 100%;">
              <a-select-option value="常考题">常考题</a-select-option>
              <a-select-option value="易错题">易错题</a-select-option>
            </a-select>
          </div>
          <div class="form-group">
            <div class="label">相似题:</div>
            <a-radio-group v-model="form.systag">
              <a-radio :value="1" :key="1">否
              </a-radio>
              <a-radio :value="0" :key="0">是
              </a-radio>
            </a-radio-group>
          </div>
          <div class="form-group" v-if="form.typestr !== 'PREVIEW'">
            <or-upload v-model="form.analysisvideo" button-text="上传解析视频" delete-update />
          </div>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import OrRichInput from "@/components/rich-input.vue";
import OrUpload from "@/components/upload";

export default {
  props: {
    qid: {
      type: String,
    },
    buttonSize: {
      type: String,
    },
    buttonType: {
      type: String,
      default: "primary",
    },
    buttonText: {
      type: String,
      default: "添加题目",
    },
  },
  data() {
    return {
      fileList: [],
      visible: false,
      questionNodeList: [],
      basicGradeList: [],
      basicChapterList: [],
      basicSemesterList: [],
      questionTypes: [
        { value: "SINGLE_CHOICE", label: "单选题" },
        { value: "JUDGMENT", label: "判断题" },
        { value: "ANSWER", label: "解答题" },
        { value: "VIDEO", label: "口述题" },
        { value: "VOICE", label: "语音题" },
        { value: "PREVIEW", label: "预习题" },
        { value: "COMPLETION", label: "填空题" },
      ],
      form: {
        typestr: "SINGLE_CHOICE",
        node_str: undefined,
        star: 3,
        options: [""],
        title: "",
        node_id: undefined,
        answer: 1,
        previewvideo: undefined,
        analysisvideo: "",
        analysis: "",
        tag: [],
        grade_id: undefined,
        chapter_id: undefined,
        semester_id: undefined,
        systag: undefined,
        need_student_analysis: 1,
        subject: undefined,
        voice: '',
      },
      answer_cnt: 1,
      node_ids: [],
      answers: [{ id: 1, val: "" }, { id: 2, val: "" }, { id: 3, val: "" }, { id: 4, val: "" }, { id: 5, val: "" }, { id: 6, val: "" }, { id: 7, val: "" }],
      // answers:[""],
    };
  },
  //
  mounted() {
  },
  methods: {
    qingchu() {
      this.form.voice = '';
    },
    //处理填空题答案
    makeAnsertForCompletion() {
      let answer = "";
      for (let i = 0; i < this.answer_cnt; i++) {
        if (this.answers[i]['val'].trim() == "") {
          return "";
        }
        answer = answer + this.answers[i]['val'].trim();
        if ((i + 1) < this.answer_cnt) {
          answer += "#";
        }
      }
      return answer;
    },
    getPopupContainer() {
      const wrap = document.getElementById(`modal${this.qid}`)
      return wrap;
    },
    getBasicGrade() {
      if (this.basicGradeList.length == 0) {
        this.$axios
          .post("/api/BasicGrade/index")
          .then((res) => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              this.basicGradeList = res.data.data;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    getBasicChapter() {
      if (this.basicChapterList.length == 0) {
        this.$axios
          .post("/api/BasicChapter/gettreeChapter")
          .then((res) => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              this.basicChapterList = res.data.series;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    getBasicSemester() {
      if (this.basicSemesterList.length == 0) {
        this.$axios
          .post("/api/BasicSemester/index")
          .then((res) => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              this.basicSemesterList = res.data.data;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

    getQuestionNodelist() {
      if (this.questionNodeList.length == 0) {
        this.$axios
          .post("/api/QuestionNode/index")
          .then((res) => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              this.questionNodeList = res.data;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    handleShow() {
      this.getQuestionNodelist();
      this.getBasicGrade();
      this.getBasicChapter();
      this.getBasicSemester();
      //有id就进行修改操作
      if (this.qid) {
        let _this = this;
        this.$axios
          .post("/api/QuestionProblems/find", {
            data: { id: _this.qid },
          })
          .then((res) => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定",
              });
            } else {
              _this.node_ids = res.data.node_ids;
              res.data = res.data.info;
              if (res.data.tag != "") {
                res.data.tag = res.data.tag.split(",");
              } else {
                res.data.tag = [];
              }
              if (res.data.typestr == "SINGLE_CHOICE") {
                res.data.options = JSON.parse(res.data.options);
                for (
                  let i = 0;
                  i < res.data.options.length;
                  i++
                ) {
                  res.data.options[i] =
                    res.data.options[i]["value"];
                }
              }
              if (res.data.typestr == "COMPLETION") {
                this.answer_cnt = res.data.answer.split("#").length;
                for (let i = 0; i < this.answer_cnt; i++) {
                  this.answers[i]['val'] = res.data.answer.split("#")[i];
                }
              }
              _this.form = res.data;
              _this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
      this.visible = true;
    },
    handleOk() {
      let data = JSON.parse(JSON.stringify(this.form));
      if (data.title == "") {
        this.$error({
          title: "错误",
          content: "没有填写题干",
          okText: "确定",
        });
        return false;
      }
      if (this.form.tag) {
        data.tag = this.form.tag.join(",");
      }

      //答案和问题信息判断开始
      switch (data.typestr) {
        case "SINGLE_CHOICE":
          if (data.options.length < 2 || data.options.length > 6) {
            this.$error({
              title: "错误",
              content: "单选题备选选项为2-6项",
              okText: "确定",
            });
            return false;
          }
          if (data.answer == "") {
            this.$error({
              title: "错误",
              content: "请选择一个正确答案",
              okText: "确定",
            });
            return false;
          } //
          //进行答案组合
          data.options = [];
          for (let i = 0; i < this.form.options.length; i++) {
            data.options.push({
              keys: String.fromCharCode(65 + i),
              value: this.form.options[i],
            });
          }
          // data.answer = String.fromCharCode(65 + this.form.answer);
          data.options = JSON.stringify(data.options);
          console.info("单选题");
          break;
        case "JUDGMENT":
          console.info("判断题");

          if (data.answer < 0 && data.answer > 1) {
            this.$error({
              title: "错误",
              content: "请选择判断题答案",
              okText: "确定",
            });
            return false;
          }

          break;
        case "COMPLETION":
          data.answer = this.makeAnsertForCompletion();
          if (data.answer == "") {
            this.$error({
              title: "错误",
              content: "答案填写错误，请检查",
              okText: "确定",
            });
            return false;
          }
          console.info("填空题");
          break;
        case "ANSWER":
          console.info("解答题");
          break;
        case "VIDEO":
          console.info("口述题");
          break;
        case "PREVIEW":
          if (data.previewvideo == "") {
            this.$error({
              title: "错误",
              content: "预习题必须上传视频",
              okText: "确定",
            });
            return false;
          }
          console.info("预习题");
          break;
        default:
          console.info("不支持的题型");
      }
      if (!data.node_id) {
        this.$error({
          title: "错误",
          content: "必须选择一个主知识点",
          okText: "确定",
        });
        return false;
      }
      //不是预习题就都需要填写解析 不进行文字解析验证
      // if (data.typestr != "PREVIEW"   && data.analysis == "") {
      //   this.$error({
      //     title: "错误",
      //     content: "请填写文字解析",
      //     okText: "确定",
      //   });
      //   return false;
      // }
      let node_ids = [];
      for (let j = 0; j < this.node_ids.length; j++) {
        node_ids.push(this.node_ids[j]["value"]);
      }

      //判断是修改还是新增
      let url = "/api/QuestionProblems/edit";
      if (!data.id) {
        url = "/api/QuestionProblems/add";
      }
      this.$axios
        .post(url, {
          data: { problems: data, node_ids: node_ids },
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.visible = false;
            this.$emit("save");
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleCancel() {
      this.visible = false;
    },
    handleAddOption() {
      this.form.options.push("");
      this.$forceUpdate();
    },
    handleRemoveOption(index) {
      this.form.options.splice(index, 1);
      this.$forceUpdate();
    },
    handleQuestionTypeChanged(e) {
      this.form.answer = "";
      this.form.options = "";
      switch (e.target.value) {
        case "SINGLE_CHOICE":
          this.form.options = ["", "", ""];
          console.info("单选题");
          break;
        case "JUDGMENT":
          this.form.answer = 0;
          console.info("判断题");
          break;
        case "COMPLETION":
          console.info("填空题");
          break;
        case "ANSWER":
          console.info("解答题");
          break;
        case "VIDEO":
          console.info("口述题");
          break;
        case "PREVIEW":
          this.form.analysis = "";
          console.info("预习题");
          break;
        default:
          console.info("不支持的题型");
      }
      this.$forceUpdate();
    },
    handleOptionInput(index, data) {
      this.form.options.splice(index, 1, data);
    },
  },
  components: { OrRichInput, OrUpload },
};
</script>

<style lang="less" scoped>
.inline {
  display: inline;
}

.uploader {
  display: block;
}

.form-group {
  position: relative;
  margin-bottom: 1rem;

  .remove {
    position: absolute;
    cursor: pointer;
    top: 0.5rem;
    right: 0.5rem;

    &:hover {
      color: #ff4d4f;
    }
  }

  .label {
    color: rgba(0, 0, 0, 0.35);
    width: 5.5rem;
    margin-right: 1rem;
    float: left;
    line-height: 2rem;
  }

  /deep/ .ant-radio-group {
    line-height: 2rem;
  }

  .knowledge {
    width: 100%;
  }
}

.preview {
  width: 100%;

  margin-bottom: 16px;
}

.tree {
  background-color: #f8f8f8;
  border-radius: 4px;
  padding: 4px 12px;
  margin-bottom: 1rem;
}
</style>